export default {
      id: "whatsapp-negative-usage",
      viewBox: "0 0 512 512",
      url: "/assets/svg/" + "sprite.svg#whatsapp-negative-usage",
      toString: function () {
        return this.url;
      }
    }